<template>
    <div class="dob-container">
        <CustomDatePicker @cancel="closeModal" @apply="updateDob($event)" :isApplying="isUpdatingDob" :initial-date="dob" />
    </div>
</template>

<script setup lang="ts">
import CustomDatePicker from '~/components/main/shared/CustomDatePicker.vue';
import { ModalNames } from '~/types/modals';

const personStore = usePersonStore();
const dob = ref<Date | undefined>(personStore.person?.dob ? new Date(personStore.person?.dob) : undefined);

const isUpdatingDob = ref(false);

const updateDob = async (value: Date) => {
    isUpdatingDob.value = true;
    // Create a new date with the same year, month, and day but at noon to avoid timezone issues
    const dateAtNoon = new Date(value.getFullYear(), value.getMonth(), value.getDate(), 12, 0, 0);
    const updatePayload: any = {
        first_name: personStore.person?.first_name,
        dob: dateAtNoon.toISOString(),
    };
    if (personStore.person?.middle_name !== null) {
        updatePayload.middle_name = personStore?.person?.middle_name;
    }
    if (personStore.person?.last_name !== null) {
        updatePayload.last_name = personStore?.person?.last_name;
    }
    await personStore.updatePerson(updatePayload);
    isUpdatingDob.value = false;
    closeModal();
};

const dialogRef = getDialogRef(ModalNames.EDIT_DOB);

const closeModal = () => {
    dialogRef.value.close();
};
</script>

<style scoped lang="scss">
.dob-container {
    @apply rounded-md sm:p-6 p-0 flex flex-col gap-6;
}
</style>
